// extracted by mini-css-extract-plugin
module.exports = {"flexSpace":"FlexSpace_flexSpace__17Amp"};